module.exports = __webpack_public_path__ + "img/alex-supper.ae43d9b7.jpg";